<template>
  <div>
    <div class="vx-row" v-show="mobileLoading || desktopLoading">
      <div id="loading" class="vs-con-loading__container"></div>
    </div>

    <Modal :isVisible="isModalVisible" @close="closeModal">
      <div v-if="this.$i18n.locale === 'pt'" class="w-full">
        <iframe
          id="panda-59f25f45-c507-45b2-a10f-ad92d3301c0b"
          src="https://player-vz-39e9409a-f54.tv.pandavideo.com.br/embed/?v=59f25f45-c507-45b2-a10f-ad92d3301c0b"
          style="border:none;"
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
          allowfullscreen="true"
          fetchpriority="high"
          class="w-full lg:h-screen video-player object-cover !z-10"
        ></iframe>
      </div>

      <div v-if="this.$i18n.locale === 'en'" class="w-full">
        <iframe
          id="panda-1ec64309-54d7-41d4-9d30-ff0da67b674a"
          src="https://player-vz-39e9409a-f54.tv.pandavideo.com.br/embed/?v=1ec64309-54d7-41d4-9d30-ff0da67b674a&startTime=2"
          style="border:none;"
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture"
          allowfullscreen="true"
          fetchpriority="high"
          class="w-full lg:h-screen video-player object-cover !z-10"
        ></iframe>
      </div>

      <template #title-video>
        <div class="flex flex-col gap-y-2">
          <h1 class="text-white font-semibold text-xl">{{ currentVideoTitle }}</h1>
          <p class="text-white underline">{{ currentVideo }}</p>
        </div>

        <div class="w-full flex items-center justify-center mt-8 flex-col gap-y-3">
          <button class="btn-video cursor-pointer btn-pulse" @click="toggleFullscreen">
            {{ $t('watchInFullScreenMode') }}
          </button>

          <p class="text-white cursor-pointer underline font-semibold text-lg">
            {{ $t('shareVideo') }}
          </p>
        </div>
      </template>

      <template v-if="!isLastVideo" #next-videos>
        <div class="flex flex-col gap-y-4 mt-5">
          <div
            v-for="(video, index) in nextVideos.slice(currentIndex + 1)"
            :key="index"
            class="flex gap-x-4 items-center cursor-pointer"
            @click="playVideo(video)"
          >
            <img
              :src="video.thumb"
              alt="Miniatura do vídeo"
              class="rounded-lg lg:w-auto lg:h-48"
              style="width: 164px; height: 100px;"
            />
            <p class="text-white">{{ video.title }}</p>
          </div>
        </div>
      </template>

      <template v-else #next-videos>
        <div class="flex flex-col w-full gap-y-4 mt-5 items-center">
          <div class="flex items-center w-full gap-x-5">
            <img
              src="/assets/images/pages/banner-loves-game.png"
              alt="Miniatura do Jogo do Amor"
              class="next-video-thumbnail"
            />
            <div class="flex flex-col gap-y-2">
              <p class="text-white text-lg font-semibold">{{ $t('lovesGameTitle') }}</p>
              <p class="text-sm font-semibold">
                {{ $t('lovesGameDesc') }}
              </p>
              <button @click="loadMoreVideos" class="btn-more-video-game-love">
                {{ $t('lovesGameButton') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base">
        <h1
          class="font-light text-white title-sparkle text-lg lg:hidden flex self-center items-center justify-center gap-x-1 ml-4 text-center"
        >
          <feather-icon icon="ArrowDownIcon" svgClasses="h-4 w-4" />
          {{ $t('watchNowVideo') }}
          <feather-icon icon="ArrowDownIcon" svgClasses="h-4 w-4" />
        </h1>

        <vx-card class="p-2 bg-transparent shadow-none">
          <div class="relative w-full module-video">
            <img :src="getBannerImage" class="mb-5 w-full h-full object-cover img-preview-video" />

            <button
              class="absolute btn-play flex items-center justify-center"
              @click="openModal"
              aria-label="Assistir vídeo"
            >
              <img src="/assets/images/pages/play.svg" class="w-5 h-5 mr-2 -ml-2" />
              {{ $t('lovesGameButton') }}
            </button>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-col w-full mb-4">
      <h1 class="text-white ml-4">{{ $t('watchNext') }}</h1>

      <div class="vx-row mt-5">
        <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base">
          <vx-card class="p-2 bg-transparent shadow-none">
            <div class="relative w-full module-video">
              <img :src="getBannerImageLovesGame" class="mb-5 w-full h-full object-cover img-preview-video" />

              <button
                class="absolute btn-play flex items-center justify-center"
                @click="openModalLovesGame"
                aria-label="Assistir vídeo"
              >
                <img src="/assets/images/pages/play.svg" class="w-5 h-5 mr-2 -ml-2" />
                {{ $t('lovesGameButton') }}
              </button>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../components/Modal.vue';

export default {
  components: { Modal },
  data() {
    return {
      isModalVisible: false,
      currentVideoUrl: '',
      currentVideoTitle: '',
      currentVideo: '',
      currentIndex: 0,
      nextVideos: [],
      videoList: {
        PT: [
          {
            id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/video01_att.mp4',
            currentVideo: 'Vídeo 1',
            title: 'Bem-vindo',
            thumb: '/assets/images/membros/THUMB1PT.jpg'
          }
          // { id: "https://detetiveai.s3.us-east-1.amazonaws.com/membros/video02.mp4", currentVideo: 'Vídeo 2', title: "Como instalar", thumb: "/assets/images/membros/THUMB2PT.jpg" },
        ],
        EN: [
          {
            id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/video01_att.mp4',
            currentVideo: 'Video 1',
            title: 'Welcome',
            thumb: '/assets/images/membros/THUMB1EN.jpg'
          }
          // { id: "https://detetiveai.s3.us-east-1.amazonaws.com/membros/video02EN.mp4", currentVideo: 'Video 2', title: "How to install", thumb: "/assets/images/membros/THUMB2EN.jpg" },
        ]
      }
    };
  },
  computed: {
    isLastVideo() {
      return this.currentIndex === this.nextVideos.length - 1;
    },
    getBannerImage() {
      const currentLocale = this.$i18n.locale;
      return `/assets/images/pages/banner2${currentLocale.toUpperCase()}.jpg`;
    },
    getBannerImageLovesGame() {
      return `/assets/images/pages/BANNER2.png`;
    }
  },
  methods: {
    handleVideoEnded() {
      if (this.currentIndex < this.nextVideos.length - 1) {
        this.setCurrentVideo(this.currentIndex + 1);
      } else {
        console.log('Último vídeo reproduzido.');
      }
    },
    loadMoreVideos() {
      this.nextVideos = [
        {
          id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/love-game/video01.mp4',
          currentVideo: 'Vídeo 1',
          title: 'Boas Vindas',
          thumb: '/assets/images/membros/loves-game/THUMB1.png'
        },
        {
          id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/love-game/video02.mp4',
          currentVideo: 'Vídeo 2',
          title: 'Painel e Funções',
          thumb: '/assets/images/membros/loves-game/THUMB2.png'
        },
        {
          id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/love-game/video03.mp4',
          currentVideo: 'Vídeo 3',
          title: 'Como Funciona',
          thumb: '/assets/images/membros/loves-game/THUMB3.png'
        }
      ];

      this.setCurrentVideo(0);

      if (!this.isModalVisible) {
        this.isModalVisible = true;
      }
    },
    updateThumbnailsAndVideos() {
      const currentLocale = this.$i18n.locale;
      this.nextVideos = this.videoList[currentLocale.toUpperCase()] || this.videoList.PT;
    },
    openModal() {
      const currentLocale = this.$i18n.locale;
      this.nextVideos = this.videoList[currentLocale.toUpperCase()] || this.videoList.PT;
      this.setCurrentVideo(0);
      this.currentVideoUrl = this.nextVideos[0].id;
      this.currentVideoTitle = this.nextVideos[0].title;
      this.currentVideo = this.nextVideos[0].currentVideo;
      this.thumb = this.nextVideos[0].thumb;
      this.isModalVisible = true;
    },
    openModalLovesGame() {
      this.nextVideos = [
        {
          id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/love-game/video01.mp4',
          currentVideo: 'Vídeo 1',
          title: 'Boas Vindas',
          thumb: '/assets/images/membros/loves-game/THUMB1.png'
        },
        {
          id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/love-game/video02.mp4',
          currentVideo: 'Vídeo 2',
          title: 'Painel e Funções',
          thumb: '/assets/images/membros/loves-game/THUMB2.png'
        },
        {
          id: 'https://detetiveai.s3.us-east-1.amazonaws.com/membros/love-game/video03.mp4',
          currentVideo: 'Vídeo 3',
          title: 'Como Funciona',
          thumb: '/assets/images/membros/loves-game/THUMB3.png'
        }
      ];
      this.setCurrentVideo(0);
      this.currentVideoUrl = this.nextVideos[0].id;
      this.currentVideoTitle = this.nextVideos[0].title;
      this.currentVideo = this.nextVideos[0].currentVideo;
      this.thumb = this.nextVideos[0].thumb;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.currentVideoUrl = '';
    },
    playVideo(video) {
      const index = this.nextVideos.findIndex(v => v.id === video.id);
      this.setCurrentVideo(index);
      this.isModalVisible = true;
    },
    setCurrentVideo(index) {
      this.currentIndex = index;
      this.currentVideoUrl = this.nextVideos[index].id;
      this.currentVideoTitle = this.nextVideos[index].title;
      this.currentVideo = this.nextVideos[index].currentVideo;
      this.thumb = this.nextVideos[index].thumb;
    },
    toggleFullscreen() {
      const iframe = this.$el.querySelector('.video-player');
      if (iframe) {
        if (iframe.requestFullscreen) {
          iframe.requestFullscreen();
        } else if (iframe.webkitRequestFullscreen) {
          iframe.webkitRequestFullscreen();
        } else if (iframe.mozRequestFullScreen) {
          iframe.mozRequestFullScreen();
        } else if (iframe.msRequestFullscreen) {
          iframe.msRequestFullscreen();
        } else {
          alert('Seu navegador não suporta o modo de tela cheia.');
        }
      }
    }
  },
  watch: {
    '$i18n.locale': function() {
      this.updateThumbnailsAndVideos();
    }
  },
  created() {
    this.updateThumbnailsAndVideos();
  }
};
</script>

<style>
.btn-play {
  background: #fff;
  width: 90%;
  height: 50px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: black;
  text-transform: uppercase;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  outline: none;
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.thumb-video {
  height: 380px !important;
}

.btn-play-videos {
  background: #fff;
  border-radius: 100%;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
}

.next-video-container {
  width: 134px;
  height: 80px;
  border-radius: 10px;
}

.module-video {
  height: 400px;
}

.next-video-thumbnail {
  width: 134px;
  height: 80px;
  border-radius: 10px;
  object-fit: cover;
}

.btn-video {
  background: #fff;
  border-radius: 15px;
  width: 100%;
  height: 60px;
  outline: none;
  border: none;
  font-size: 18px;
  font-weight: bold;
}

.video-player {
  outline: none;
  border: none;
  height: 254px;
  z-index: 100;
}

.img-preview-video {
  border-radius: 20px;
}

.next-video-thumbnail {
  width: 175px;
  height: 211px;
  border-radius: 22px;
}

.btn-more-video-game-love {
  background: #fff;
  width: 100%;
  height: 37px;
  border-radius: 7px;
  font-size: 14px;
  font-weight: bold;
  color: #27272a;
  outline: none;
  border: none;
  cursor: pointer;
}

.btn-pulse {
  border: none;
  animation: pulseEffect 1s infinite ease-out;
}

@keyframes pulseEffect {
  0% {
    transform: scale(1);
  }
  50% {
    box-shadow: 0 4px 2px 0 #000;
    transform: scale(1.02);
  }
  100% {
    border: none;
    transform: scale(1);
  }
}

.title-sparkle {
  animation: textSparkle 0.9s infinite;
}

@keyframes textSparkle {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>
